import { useApi } from './api'

export const apiAtividadeTipo = () => {
   const { api } = useApi()

   const registrar = async (payload) => {
      const { data } = await api.post(`atividade-tipo`, payload)
      return data
   }
   const editar = async (payload) => {
      const { data } = await api.put(`atividade-tipo/${payload.id}`, payload.body)
      return data
   }
   const obterPorId = async (id) => {
      const { data } = await api.get(`atividade-tipo/${id}`)
      return data
   }

   const obter = async (params) => {  
      const { data } = await api.get(`/atividade-tipo`, { params })
      return data
   }
   return {
      registrar,
      editar,
      obterPorId,
      obter
   }
}
